import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconColor, IconImage, IconSize } from '@interfaces/common.interface';

@Component({
  selector: 'ark-card-radio',
  templateUrl: './card-radio.component.html',
  styleUrls: ['./card-radio.component.scss'],
})
export class CardRadioComponent {
  @Input() size: 'small' | 'large' = 'large';

  @Input() label = 'Label';
  @Input() description = 'Description';
  @Input() checked = false;
  @Input() disabled = false;

  @Input() icon: IconImage = 'close';
  @Input() iconColor: IconColor = 'confirm';
  @Input() iconSize: IconSize = 'large';

  @Output() selectionChanged = new EventEmitter<{
    label: string;
    checked: boolean;
  }>();

  tickIcon: IconImage = 'tick';
  tickIconColor: IconColor = 'light';
  tickIconSize: IconSize = 'small';
  constructor() {}

  select(): void {
    this.checked = !this.checked;
    this.selectionChanged.emit({
      label: this.label,
      checked: this.checked,
    });
  }
}
